export default __webpack_public_path__ + "static/media/dynocorn.332465b9.png";